import { render, staticRenderFns } from "./Paging.vue?vue&type=template&id=1122e202&"
import script from "./Paging.vue?vue&type=script&lang=ts&"
export * from "./Paging.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports